import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { useMessageSelectionStore } from "@/features/chat/model";
import { useAuthStore } from "@/features/auth";
import { useMessagesStore } from "@/entities/message";
import { DeleteConfirmAction } from "@/shared/ui";

type SelectedMessagesActionsProps = {
  chatId?: string;
  onDeleteMessages: (ids: string[]) => void;
  onForwardMessages: (ids: string[]) => void;
};

export const SelectedMessagesActions = ({
  chatId,
  onDeleteMessages,
  onForwardMessages,
}: SelectedMessagesActionsProps) => {
  const { modeSelected, selectedMessages, resetSelection } = useMessageSelectionStore();
  const user = useAuthStore((state) => state.user);

  const canDeleteAll = useMemo(() => {
    if (selectedMessages.size === 0 || !chatId) return false;

    const allMessages = useMessagesStore.getState().messages[chatId] || [];

    const hasForeignMessage = Array.from(selectedMessages).some((id) => {
      const msg = allMessages.find((m) => m._id === id);
      return msg && msg.owner._id !== user?._id;
    });

    return !hasForeignMessage;
  }, [selectedMessages, user, chatId]);

  return (
    <div
      style={{
        paddingTop: 4,
        paddingBottom: 11,
      }}
      className="d-flex w-100 align-items-center justify-content-between ps-5 ps-lg-0"
    >
      <div className="d-flex gap-2 position-relative">
        <Button
          size="sm"
          className="text-nowrap"
          variant="outline-secondary"
          onClick={() => onForwardMessages(Array.from(selectedMessages))}
        >
          Переслать {selectedMessages.size}
        </Button>

        {canDeleteAll && (
          <DeleteConfirmAction
            placement="bottom"
            triggerElement={
              <Button
                size="sm"
                className="text-nowrap"
                variant="outline-secondary"
              >
                Удалить {selectedMessages.size}
              </Button>
            }
            confirmText="Удалить выбранные сообщения?"
            onConfirm={() => onDeleteMessages(Array.from(selectedMessages))}
          />
        )}
      </div>

      <Button size="sm" onClick={resetSelection} variant="secondary">
        Отмена
      </Button>
    </div>
  );
};